import { useState } from "react";
import axios from '../api/axiosInstance';

function getLocalDateTimeString() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

function AdminAddWeightModal({ open, user, onClose, onSuccess }) {
  const [form, setForm] = useState({
    weightInKg: "",
    pound: "",
    jin: "",
    notes: "",
    recordedAt: getLocalDateTimeString(),
  });

  const [activeField, setActiveField] = useState("weightInKg");
  const token = localStorage.getItem("token");

  const updateFields = (field, value) => {
    if (value === "") {
      setForm((prev) => ({ ...prev, weightInKg: "", pound: "", jin: "" }));
      return;
    }

    let kg = 0;
    if (field === "weightInKg") kg = parseFloat(value);
    if (field === "pound") kg = parseFloat(value) / 2.20462;
    if (field === "jin") kg = parseFloat(value) / 2;

    if (!isNaN(kg)) {
      setForm((prev) => ({
        ...prev,
        weightInKg: field === "weightInKg" ? value : kg.toFixed(2),
        pound: field === "pound" ? value : (kg * 2.20462).toFixed(1),
        jin: field === "jin" ? value : (kg * 2).toFixed(1),
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["weightInKg", "pound", "jin"].includes(name)) {
      setActiveField(name);
      updateFields(name, value);
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      await axios.post(
        "/api/Weight",
        {
          userId: user.userId,
          weightInKg: parseFloat(form.weightInKg),
          notes: form.notes,
          recordedAt: form.recordedAt,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("新增成功");
      onClose();
      if (onSuccess) onSuccess();
    } catch {
      alert("新增失敗");
    }
  };

  if (!open || !user) return null;

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">新增體重 - {user.name}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">紀錄時間</label>
                <input
                  type="datetime-local"
                  className="form-control mb-2"
                  name="recordedAt"
                  value={form.recordedAt}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">公斤 (kg)</label>
                <input
                  type="tel"
                  inputMode="decimal"        // 提示帶小數點的鍵盤
                  pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
                  step="0.1"
                  className="form-control mb-2"
                  name="weightInKg"
                  value={form.weightInKg}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">磅 (lb)</label>
                <input
                  type="tel"
                  inputMode="decimal"        // 提示帶小數點的鍵盤
                  pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
                  step="0.1"
                  className="form-control mb-2"
                  name="pound"
                  value={form.pound}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">斤</label>
                <input
                  type="tel"
                  inputMode="decimal"        // 提示帶小數點的鍵盤
                  pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
                  step="0.1"
                  className="form-control mb-2"
                  name="jin"
                  value={form.jin}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">備註</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="備註"
                  name="notes"
                  value={form.notes}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                取消
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                送出
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
    </>
  );
}

export default AdminAddWeightModal;
